import api from '../index'

export default {
  // 后端获取路由数据（当前使用本地 mock 数据）
  routeList: () => api.get('app/route/list', {
    baseURL: '/mock/',
  }),

  // 基于文件系统路由模式下，后端获取导航菜单数据（当前使用本地 mock 数据）
  menuList: () => api.get('app/menu/list', {
    baseURL: '/mock/',
  }),

  // 获取首页统计数据
  getDashboardStats: () => api.get('/admin/dashboard/stats'),

  // 获取最近活动数据
  getRecentActivities: () => api.get('/admin/dashboard/activities'),
}
